<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentAmounts /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentAmounts from '@/components/team/dashboard/modules/report/payments/ContentAmounts.vue'

export default 
{
  name: 'Amounts',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentAmounts
  }
}
</script>

<style>


</style>